import React from "react";
import { EarnComponents } from "../components/Earn";

function Earn() {
  return <EarnComponents />;
}

export default Earn;
